import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import DutyPostingService from "../services/dutyposting,service";

const CanceledDuty = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const fetchData = () => {
    DutyPostingService.getCanceledDuty().then((resp) => setData(resp.data));
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    const keyword = e.target.value.toLowerCase();
    const filteredData = data.filter(
      (row) =>
        (row.dutyNo &&
          row.dutyNo.replace(/\s+/g, "").toLowerCase() === keyword) ||
        (row.delayReason &&
          row.delayReason.replace(/\s+/g, "").toLowerCase() === keyword)
    );

    if (keyword.length > 0) {
      setFilter(true);
    } else {
      setFilter(false);
    }
    setFilteredData(filteredData);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const convertTo12HourNoSeconds = (timeStr) => {
    const [time, modifier] = timeStr.split(" ");
    const [hours, minutes] = time.split(":");
    return `${hours}:${minutes} ${modifier}`;
  };

  const columns = [
    {
      name: (
        <div className="theadcol-flex">
          <span>
            <svg
              width="24"
              height="24"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_2665_9027)">
                <path
                  d="M6.3 9.6001C2.8377 9.6001 0 12.4291 0 15.8821C0 17.2201 0.4272 18.4636 1.1505 19.4857L5.5314 27.0589C6.1449 27.8605 6.5529 27.7084 7.0632 27.0169L11.895 18.7939C11.9925 18.6169 12.069 18.4291 12.1359 18.2371C12.4425 17.4898 12.6002 16.6898 12.6 15.8821C12.6 12.4291 9.7632 9.6001 6.3 9.6001ZM6.3 12.5437C8.1648 12.5437 9.648 14.023 9.648 15.8824C9.648 17.7418 8.1648 19.2205 6.3 19.2205C4.4355 19.2205 2.952 17.7415 2.952 15.8824C2.952 14.023 4.4355 12.5437 6.3 12.5437Z"
                  fill="var(--primary-color)"
                />
                <path
                  d="M26.3249 0C24.3053 0 22.6499 1.6503 22.6499 3.6648C22.6499 4.4451 22.8989 5.1705 23.321 5.7666L25.8767 10.1844C26.2346 10.6518 26.4725 10.563 26.7701 10.1598L29.5886 5.3628C29.6456 5.2599 29.6903 5.1504 29.729 5.0382C29.9079 4.60242 30 4.13588 29.9999 3.6648C29.9999 1.65 28.3451 0 26.3249 0ZM26.3249 1.7172C27.4127 1.7172 28.2779 2.58 28.2779 3.6648C28.2779 4.7493 27.4127 5.6118 26.3249 5.6118C25.2374 5.6118 24.3719 4.7493 24.3719 3.6648C24.3719 2.58 25.2374 1.7172 26.3249 1.7172Z"
                  fill="var(--primary-color)"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M26.4626 11.2236C25.7885 11.2386 25.1126 11.2671 24.4355 11.3172L24.5399 12.9768C25.1903 12.9297 25.8418 12.8994 26.4938 12.8859L26.4626 11.2236ZM22.8701 11.4696C21.8291 11.5989 20.7791 11.7831 19.7411 12.0792L20.132 13.6875C21.0752 13.4187 22.0526 13.245 23.0453 13.1217L22.8701 11.4696ZM18.1868 12.636C17.8758 12.7733 17.5747 12.932 17.2856 13.1109L17.2844 13.1124L17.2826 13.113C16.8701 13.3728 16.4354 13.7025 16.0805 14.1816C15.8234 14.5287 15.6131 14.9676 15.5639 15.4866L17.0924 15.6561C17.1038 15.5343 17.1662 15.3735 17.2784 15.2223H17.279V15.2217C17.4599 14.9769 17.7311 14.7546 18.0536 14.5512L18.0548 14.5506C18.2847 14.4088 18.524 14.2829 18.7712 14.1738L18.1868 12.636ZM17.3999 16.3965L16.409 17.667C16.6439 17.8818 16.8902 18.0468 17.1281 18.1848L17.1311 18.1863L17.1341 18.1881C17.9237 18.6372 18.7379 18.8907 19.4927 19.1313L19.9265 17.5359C19.172 17.2953 18.4607 17.0631 17.8511 16.7169C17.6765 16.6155 17.5235 16.5096 17.3999 16.3965ZM21.4004 17.9847L20.9768 19.5828L21.1772 19.6452L21.4232 19.7238C22.2374 19.9887 23.0174 20.2716 23.7146 20.6631L24.422 19.1871C23.579 18.7134 22.7039 18.4038 21.8606 18.1296L21.8582 18.129L21.6056 18.0483L21.4004 17.9847ZM25.8605 20.2947L24.7736 21.4707C25.0304 21.7488 25.2227 22.0833 25.3163 22.4289L25.3169 22.4307L25.3175 22.4334C25.4291 22.8369 25.4294 23.3115 25.3421 23.7909L26.8493 24.1125C26.9723 23.4357 26.9921 22.6926 26.7899 21.9591C26.6138 21.3105 26.2778 20.7471 25.8605 20.2947ZM24.8159 24.7929C24.6498 24.9684 24.4663 25.1264 24.2681 25.2645H24.2675C23.7275 25.6443 23.1011 25.9305 22.4357 26.1765L22.9319 27.7497C23.6597 27.4806 24.407 27.1506 25.1054 26.6592L25.1072 26.6577L25.1081 26.6571C25.3949 26.4563 25.6602 26.2264 25.8998 25.971L24.8159 24.7929ZM21.0239 26.6196C20.06 26.8788 19.0748 27.0762 18.0776 27.2436L18.3128 28.8873C19.3391 28.7148 20.3696 28.5087 21.3938 28.2333L21.0239 26.6196ZM16.5773 27.4704C15.5735 27.6075 14.5643 27.7194 13.5521 27.8148L13.6847 29.4714C14.7125 29.3748 15.7421 29.2611 16.7702 29.1204L16.5773 27.4704ZM12.0308 27.9453C11.0165 28.0257 9.9998 28.0911 8.9822 28.1463L9.059 29.8071C10.0865 29.7516 11.1149 29.6853 12.143 29.6037L12.0308 27.9453ZM7.4531 28.2213C6.8432 28.2498 6.2318 28.2732 5.6189 28.2948L5.6693 29.9571C6.28603 29.9359 6.90264 29.9113 7.5191 29.8833L7.4531 28.2213Z"
                  fill="var(--primary-color)"
                />
              </g>
              <defs>
                <clipPath id="clip0_2665_9027">
                  <rect width="30" height="30" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span>Duty No</span>
        </div>
      ),
      selector: (row) => row.dutyNo,
      sortable: true,
    },
    {
      name: (
        <div className="theadcol-flex">
          <span>Cancelation Reason</span>
        </div>
      ),
      selector: (row) => row.delayReason,
      cell: (row, index) => (
        <>
          <div className="busno">
            <span>{row.delayReason}</span>
          </div>
        </>
      ),
      sortable: true,
    },
    {
      name: (
        <div className="theadcol-flex">
          <span>Duty Start Time</span>
        </div>
      ),
      selector: (row) => row.dutyStartTime,
      cell: (row) => (
        <>
          <div className="">{parseFloat(row.timeTo).toFixed(2)}</div>
        </>
      ),
      sortable: true,
    },
    {
      name: (
        <div className="theadcol-flex">
          <span>Canceled On</span>
        </div>
      ),
      selector: (row) => row.transactiondate,
      cell: (row) => (
        <>
          <div className="">{row.transactiondate}</div>
        </>
      ),
      sortable: true,
    },
  ];

  return (
    <>
      <div className="search-bar">
        <input
          type="text"
          placeholder="Click here to Search by Duty No."
          name="search"
          value={search}
          onChange={handleSearch}
        />
        <div className="search-icon">
          <span>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.8938 13.8677L17.5 17.5M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
                stroke="#A79EB7"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </div>
      </div>
      <div className="datatable canceled-duty">
        <DataTable
          columns={columns}
          data={filter ? filteredData : data}
          fixedHeader
        />
      </div>
    </>
  );
};

export default CanceledDuty;
